import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "state"
}
const _hoisted_2 = {
  key: 1,
  class: "wrap"
}
const _hoisted_3 = { class: "hero" }
const _hoisted_4 = { class: "hero-top" }
const _hoisted_5 = { class: "sub" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "product-tag"
}
const _hoisted_8 = { class: "hero-grid" }
const _hoisted_9 = { class: "hero-foot" }
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 0,
  class: "readonly"
}
const _hoisted_12 = {
  key: 0,
  class: "banner warn"
}
const _hoisted_13 = { class: "banner-actions" }
const _hoisted_14 = {
  key: 1,
  class: "banner info"
}
const _hoisted_15 = {
  key: 2,
  class: "banner bad"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 3,
  class: "banner ok"
}
const _hoisted_18 = { class: "actions" }
const _hoisted_19 = { class: "segment" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 4 }
const _hoisted_22 = {
  key: 0,
  class: "empty"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "item-top" }
const _hoisted_25 = { class: "muted" }
const _hoisted_26 = { class: "muted" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 0,
  class: "warn-text"
}
const _hoisted_29 = {
  key: 1,
  class: "last-fb"
}
const _hoisted_30 = { key: 5 }
const _hoisted_31 = {
  key: 0,
  class: "empty"
}
const _hoisted_32 = { class: "item-top" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "muted" }
const _hoisted_35 = { class: "notes" }
const _hoisted_36 = {
  key: 0,
  class: "muted"
}
const _hoisted_37 = ["href"]
const _hoisted_38 = { key: 6 }
const _hoisted_39 = { class: "item-top" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "muted" }
const _hoisted_42 = {
  key: 0,
  class: "notes"
}
const _hoisted_43 = {
  key: 0,
  class: "sub-h"
}
const _hoisted_44 = { class: "item-top" }
const _hoisted_45 = { class: "status" }
const _hoisted_46 = { class: "muted" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = {
  key: 7,
  class: "details"
}
const _hoisted_49 = { class: "sub-h" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "d-row" }
const _hoisted_52 = { class: "d-row" }
const _hoisted_53 = { class: "field" }
const _hoisted_54 = { class: "field" }
const _hoisted_55 = { class: "field" }
const _hoisted_56 = { class: "field" }
const _hoisted_57 = { class: "field" }
const _hoisted_58 = { class: "field" }
const _hoisted_59 = { class: "field" }
const _hoisted_60 = { class: "check-row" }
const _hoisted_61 = { class: "field" }
const _hoisted_62 = { class: "field" }
const _hoisted_63 = { class: "field" }
const _hoisted_64 = { class: "field" }
const _hoisted_65 = { class: "field" }
const _hoisted_66 = { class: "field" }
const _hoisted_67 = { class: "field" }
const _hoisted_68 = { class: "field" }
const _hoisted_69 = { class: "field" }
const _hoisted_70 = { class: "field" }
const _hoisted_71 = ["placeholder"]
const _hoisted_72 = { class: "field" }
const _hoisted_73 = { class: "field" }
const _hoisted_74 = { class: "field" }
const _hoisted_75 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_FormSheet = _resolveComponent("FormSheet")!
  const _component_UserPicker = _resolveComponent("UserPicker")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "custom-toolbar" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    color: "light",
                    onClick: _ctx.goBack
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.arrowBackOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { class: "custom-title" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.lead ? _ctx.lead.lead_code : 'Lead'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    color: "light",
                    onClick: _ctx.load
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.refreshOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "page-bg"
      }, {
        default: _withCtx(() => [
          (!_ctx.lead)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner, { name: "crescent" })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.lead.company_name), 1),
                      _createElementVNode("div", _hoisted_5, [
                        _createTextVNode(_toDisplayString(_ctx.lead.contact_name), 1),
                        (_ctx.lead.contact_designation)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, ", " + _toDisplayString(_ctx.lead.contact_designation), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.lead.product)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.lead.product.name), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", {
                      class: "pill",
                      style: _normalizeStyle({ background: _ctx.stageColor(_ctx.lead.stage) })
                    }, _toDisplayString(_ctx.label(_ctx.lead.stage)), 5)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _cache[36] || (_cache[36] = _createElementVNode("small", null, "Value", -1)),
                      _createElementVNode("b", null, _toDisplayString(_ctx.money(_ctx.lead.expected_value)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[37] || (_cache[37] = _createElementVNode("small", null, "Probability", -1)),
                      _createElementVNode("b", null, _toDisplayString(_ctx.lead.probability) + "%", 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("small", null, _toDisplayString(_ctx.unitLabel) + "s", 1),
                      _createElementVNode("b", null, _toDisplayString(_ctx.lead.units || _ctx.lead.estimated_ships), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[38] || (_cache[38] = _createElementVNode("small", null, "Priority", -1)),
                      _createElementVNode("b", {
                        style: _normalizeStyle({ color: _ctx.priorityColor(_ctx.lead.priority) })
                      }, _toDisplayString(_ctx.lead.priority), 5)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", null, [
                      _cache[39] || (_cache[39] = _createTextVNode("Owner: ", -1)),
                      _createElementVNode("b", null, _toDisplayString(_ctx.lead.owner ? _ctx.lead.owner.name : ''), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass({ overdue: _ctx.lead.status === 'Open' && _ctx.past(_ctx.lead.next_follow_up_at) })
                    }, " Follow-up: " + _toDisplayString(_ctx.format(_ctx.lead.next_follow_up_at)), 3)
                  ]),
                  _createElementVNode("a", {
                    class: "call-btn",
                    href: 'tel:' + _ctx.lead.contact_phone
                  }, [
                    _createVNode(_component_ion_icon, { icon: _ctx.callOutline }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.lead.contact_phone), 1)
                  ], 8, _hoisted_10),
                  (_ctx.permissions.read_only)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Read-only"))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.lead.pending_transfer)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _cache[40] || (_cache[40] = _createElementVNode("b", null, "Transfer pending:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.transferText(_ctx.lead.pending_transfer)) + " ", 1),
                      _createElementVNode("div", _hoisted_13, [
                        (_ctx.permissions.can_decide_transfer)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "mini ok",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.decideTransfer('approve')))
                            }, "Approve"))
                          : _createCommentVNode("", true),
                        (_ctx.permissions.can_decide_transfer)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "mini bad",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.decideTransfer('reject')))
                            }, "Reject"))
                          : _createCommentVNode("", true),
                        (_ctx.permissions.can_cancel_transfer)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "mini",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelTransfer && _ctx.cancelTransfer(...args)))
                            }, "Cancel request"))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.lead.stage === 'Converted')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createTextVNode(" Sale #" + _toDisplayString(_ctx.lead.converted_sale_id) + " is waiting for approval. The lead becomes ", 1),
                      _cache[41] || (_cache[41] = _createElementVNode("b", null, "Won", -1)),
                      _cache[42] || (_cache[42] = _createTextVNode(" when it is approved, or goes back to Negotiation if cancelled. ", -1))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.lead.status === 'Lost' || _ctx.lead.status === 'Disqualified')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _cache[43] || (_cache[43] = _createTextVNode(" Closed as ", -1)),
                      _createElementVNode("b", null, _toDisplayString(_ctx.lead.status), 1),
                      _createTextVNode(": " + _toDisplayString(_ctx.lead.lost_reason), 1),
                      (_ctx.lead.lost_note)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, " — " + _toDisplayString(_ctx.lead.lost_note), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.lead.sale_summary)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Sale #" + _toDisplayString(_ctx.lead.sale_summary.id) + " · " + _toDisplayString(_ctx.lead.sale_summary.status) + " · " + _toDisplayString(_ctx.money(_ctx.lead.sale_summary.total_value)) + " · requisitions " + _toDisplayString(_ctx.lead.sale_summary.requisitions) + ", installed " + _toDisplayString(_ctx.lead.sale_summary.installations_complete), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_18, [
                  (_ctx.permissions.can_log_activity)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openSheet('activity')))
                      }, [
                        _createVNode(_component_ion_icon, { icon: _ctx.chatbubbleEllipsesOutline }, null, 8, ["icon"]),
                        _cache[44] || (_cache[44] = _createTextVNode("Log activity", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.permissions.can_schedule_meeting)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openSheet('meeting')))
                      }, [
                        _createVNode(_component_ion_icon, { icon: _ctx.calendarOutline }, null, 8, ["icon"]),
                        _cache[45] || (_cache[45] = _createTextVNode("Meeting", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.permissions.can_change_stage)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openSheet('stage')))
                      }, [
                        _createVNode(_component_ion_icon, { icon: _ctx.trendingUpOutline }, null, 8, ["icon"]),
                        _cache[46] || (_cache[46] = _createTextVNode("Stage", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.permissions.can_convert)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "primary",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.convert && _ctx.convert(...args)))
                      }, [
                        _createVNode(_component_ion_icon, { icon: _ctx.checkmarkDoneOutline }, null, 8, ["icon"]),
                        _cache[47] || (_cache[47] = _createTextVNode("Convert to Sale", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.permissions.can_request_transfer)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 4,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openSheet('transfer')))
                      }, [
                        _createVNode(_component_ion_icon, { icon: _ctx.swapHorizontalOutline }, null, 8, ["icon"]),
                        _cache[48] || (_cache[48] = _createTextVNode("Transfer", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.permissions.can_edit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 5,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push('/sales-lead-form/' + _ctx.lead.id)))
                      }, [
                        _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"]),
                        _cache[49] || (_cache[49] = _createTextVNode("Edit", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.permissions.can_close)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 6,
                        class: "danger",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openSheet('close')))
                      }, [
                        _createVNode(_component_ion_icon, { icon: _ctx.closeCircleOutline }, null, 8, ["icon"]),
                        _cache[50] || (_cache[50] = _createTextVNode("Close", -1))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (t) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: t.key,
                      class: _normalizeClass({ on: _ctx.tab === t.key }),
                      onClick: ($event: any) => (_ctx.tab = t.key)
                    }, _toDisplayString(t.label), 11, _hoisted_20))
                  }), 128))
                ]),
                (_ctx.tab === 'meetings')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (!_ctx.lead.meetings.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, "No meetings yet."))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lead.meetings, (m) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: m.id,
                          class: _normalizeClass(["item", { overdue: m.feedback_overdue }]),
                          onClick: ($event: any) => (_ctx.$router.push('/sales-lead-meeting/' + m.id))
                        }, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("b", null, _toDisplayString(m.meeting_type), 1),
                            _cache[51] || (_cache[51] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_25, "· " + _toDisplayString(m.mode), 1),
                            _createElementVNode("span", {
                              class: _normalizeClass(["status", 'st-' + m.status.toLowerCase()])
                            }, _toDisplayString(m.status), 3)
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createTextVNode(_toDisplayString(_ctx.format(m.scheduled_at)), 1),
                            (m.location)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, " · " + _toDisplayString(m.location), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (m.feedback_overdue)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, "Feedback overdue"))
                            : _createCommentVNode("", true),
                          (m.feedbacks.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createElementVNode("b", null, _toDisplayString(m.feedbacks[m.feedbacks.length - 1].outcome), 1),
                                _createTextVNode(" (" + _toDisplayString(m.feedbacks[m.feedbacks.length - 1].client_sentiment) + ") — " + _toDisplayString(m.feedbacks[m.feedbacks.length - 1].feedback), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_23))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tab === 'activities')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      (!_ctx.lead.activities.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, "No activities logged yet."))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lead.activities, (a) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: a.id,
                          class: "item"
                        }, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("b", null, _toDisplayString(a.type), 1),
                            (a.outcome)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, " — " + _toDisplayString(a.outcome), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.format(a.activity_at)) + " · " + _toDisplayString(a.created_by ? a.created_by.name : ''), 1),
                          _createElementVNode("div", _hoisted_35, _toDisplayString(a.notes), 1),
                          (a.next_follow_up_at)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Next follow-up: " + _toDisplayString(_ctx.format(a.next_follow_up_at)), 1))
                            : _createCommentVNode("", true),
                          (a.attachment_url)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: a.attachment_url,
                                target: "_blank",
                                class: "link"
                              }, "View attachment", 8, _hoisted_37))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tab === 'history')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lead.stage_logs, (log) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 's' + log.id,
                          class: "item"
                        }, [
                          _createElementVNode("div", _hoisted_39, [
                            (log.from_stage && log.from_stage !== log.to_stage)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.label(log.from_stage)) + " → ", 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("b", null, _toDisplayString(_ctx.label(log.to_stage)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.format(log.created_at)) + " · " + _toDisplayString(log.changed_by ? log.changed_by.name : 'System'), 1),
                          (log.note)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(log.note), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      (_ctx.lead.transfers.length)
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_43, "Ownership"))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lead.transfers, (t) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 't' + t.id,
                          class: "item"
                        }, [
                          _createElementVNode("div", _hoisted_44, [
                            _createTextVNode(_toDisplayString(_ctx.transferText(t)) + " ", 1),
                            _createElementVNode("span", _hoisted_45, _toDisplayString(t.status), 1)
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createTextVNode(_toDisplayString(_ctx.format(t.created_at)), 1),
                            (t.response_note)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_47, " · " + _toDisplayString(t.response_note), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tab === 'details')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailRows, (row) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: row[0],
                          class: "d-row"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(row[0]), 1),
                          _createElementVNode("b", null, _toDisplayString(row[1] || '—'), 1)
                        ]))
                      }), 128)),
                      _createElementVNode("h4", _hoisted_49, [
                        _cache[52] || (_cache[52] = _createTextVNode("Deal", -1)),
                        (_ctx.lead.contract_months)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, " · " + _toDisplayString(_ctx.lead.contract_months) + " months expected", 1))
                          : _createCommentVNode("", true)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lead.items || [], (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'i' + item.id,
                          class: "d-row"
                        }, [
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(item.name), 1),
                            _cache[53] || (_cache[53] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("small", null, [
                              _createTextVNode(_toDisplayString(item.quantity) + " × " + _toDisplayString(_ctx.money(item.unit_price)), 1),
                              (item.charge_type === 'recurring')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" × " + _toDisplayString(item.periods) + " " + _toDisplayString(_ctx.periodWord(item.billing_period)) + "s", 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (Number(item.vat_rate))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" + VAT " + _toDisplayString(Number(item.vat_rate)) + "%", 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("b", null, _toDisplayString(_ctx.money(item.total)), 1)
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_51, [
                        _cache[54] || (_cache[54] = _createElementVNode("span", null, "Subtotal / VAT", -1)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.money(_ctx.lead.subtotal)) + " / " + _toDisplayString(_ctx.money(_ctx.lead.vat_amount)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _cache[55] || (_cache[55] = _createElementVNode("span", null, "Total", -1)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.money(_ctx.lead.expected_value)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])),
          _createVNode(_component_FormSheet, {
            open: _ctx.sheet === 'stage',
            title: "Change stage",
            busy: _ctx.busy,
            onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sheet = null)),
            onSubmit: _ctx.submitStage
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_53, [
                _cache[56] || (_cache[56] = _createElementVNode("label", null, "New stage", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.stageForm.stage) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openStages, (s) => {
                    return (_openBlock(), _createElementBlock("option", { key: s }, _toDisplayString(s), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.stageForm.stage]
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _cache[57] || (_cache[57] = _createElementVNode("label", null, "Note", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.stageForm.note) = $event)),
                  maxlength: "250"
                }, null, 512), [
                  [_vModelText, _ctx.stageForm.note]
                ])
              ]),
              _cache[58] || (_cache[58] = _createElementVNode("div", { class: "hint" }, "To win a lead use Convert to Sale; to lose it use Close.", -1))
            ]),
            _: 1
          }, 8, ["open", "busy", "onSubmit"]),
          _createVNode(_component_FormSheet, {
            open: _ctx.sheet === 'activity',
            title: "Log activity",
            busy: _ctx.busy,
            onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sheet = null)),
            onSubmit: _ctx.submitActivity
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_55, [
                _cache[59] || (_cache[59] = _createElementVNode("label", null, "Type", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.activityForm.type) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meta ? _ctx.meta.activity_types : [], (t) => {
                    return (_openBlock(), _createElementBlock("option", { key: t }, _toDisplayString(t), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.activityForm.type]
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _cache[60] || (_cache[60] = _createElementVNode("label", null, "Outcome", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.activityForm.outcome) = $event)),
                  maxlength: "255",
                  placeholder: "e.g. Asked for a price quote"
                }, null, 512), [
                  [_vModelText, _ctx.activityForm.outcome]
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _cache[61] || (_cache[61] = _createElementVNode("label", null, [
                  _createTextVNode("Notes "),
                  _createElementVNode("span", { class: "req" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.activityForm.notes) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.activityForm.notes]
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _cache[62] || (_cache[62] = _createElementVNode("label", null, "Next follow-up", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.activityForm.next_follow_up_at) = $event)),
                  type: "datetime-local"
                }, null, 512), [
                  [_vModelText, _ctx.activityForm.next_follow_up_at]
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _cache[63] || (_cache[63] = _createElementVNode("label", null, "Attachment", -1)),
                _createElementVNode("input", {
                  type: "file",
                  accept: "image/*,application/pdf",
                  onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onFile($event, 'activity')))
                }, null, 32)
              ]),
              _createElementVNode("label", _hoisted_60, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.activityForm.withLocation) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.activityForm.withLocation]
                ]),
                _cache[64] || (_cache[64] = _createTextVNode(" Attach my current location (proof of visit)", -1))
              ])
            ]),
            _: 1
          }, 8, ["open", "busy", "onSubmit"]),
          _createVNode(_component_FormSheet, {
            open: _ctx.sheet === 'meeting',
            title: "Schedule meeting",
            "submit-label": "Schedule",
            busy: _ctx.busy,
            onClose: _cache[27] || (_cache[27] = ($event: any) => (_ctx.sheet = null)),
            onSubmit: _ctx.submitMeeting
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_61, [
                _cache[65] || (_cache[65] = _createElementVNode("label", null, "Type", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.meetingForm.meeting_type) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meta ? _ctx.meta.meeting_types : [], (t) => {
                    return (_openBlock(), _createElementBlock("option", { key: t }, _toDisplayString(t), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.meetingForm.meeting_type]
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _cache[66] || (_cache[66] = _createElementVNode("label", null, "Mode", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.meetingForm.mode) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meta ? _ctx.meta.meeting_modes : [], (t) => {
                    return (_openBlock(), _createElementBlock("option", { key: t }, _toDisplayString(t), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.meetingForm.mode]
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _cache[67] || (_cache[67] = _createElementVNode("label", null, [
                  _createTextVNode("Date & time "),
                  _createElementVNode("span", { class: "req" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.meetingForm.scheduled_at) = $event)),
                  type: "datetime-local"
                }, null, 512), [
                  [_vModelText, _ctx.meetingForm.scheduled_at]
                ])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _cache[68] || (_cache[68] = _createElementVNode("label", null, "Location", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.meetingForm.location) = $event)),
                  maxlength: "255"
                }, null, 512), [
                  [_vModelText, _ctx.meetingForm.location]
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _cache[69] || (_cache[69] = _createElementVNode("label", null, "Client attendees", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.meetingForm.attendees_client) = $event)),
                  maxlength: "255"
                }, null, 512), [
                  [_vModelText, _ctx.meetingForm.attendees_client]
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _cache[70] || (_cache[70] = _createElementVNode("label", null, "Our attendees (they get a notification)", -1)),
                _createVNode(_component_UserPicker, {
                  modelValue: _ctx.meetingForm.attendees_internal,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.meetingForm.attendees_internal) = $event)),
                  users: _ctx.meta ? _ctx.meta.users : [],
                  multiple: ""
                }, null, 8, ["modelValue", "users"])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _cache[71] || (_cache[71] = _createElementVNode("label", null, "Agenda", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.meetingForm.agenda) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.meetingForm.agenda]
                ])
              ])
            ]),
            _: 1
          }, 8, ["open", "busy", "onSubmit"]),
          _createVNode(_component_FormSheet, {
            open: _ctx.sheet === 'transfer',
            title: "Request transfer",
            "submit-label": "Request",
            busy: _ctx.busy,
            onClose: _cache[31] || (_cache[31] = ($event: any) => (_ctx.sheet = null)),
            onSubmit: _ctx.submitTransfer
          }, {
            default: _withCtx(() => [
              _cache[76] || (_cache[76] = _createElementVNode("div", {
                class: "hint",
                style: {"margin-bottom":"10px"}
              }, "The lead moves only after the owner's reporting boss approves. Until then it stays with the current owner.", -1)),
              _createElementVNode("div", _hoisted_68, [
                _cache[72] || (_cache[72] = _createElementVNode("label", null, [
                  _createTextVNode("Transfer to "),
                  _createElementVNode("span", { class: "req" }, "*")
                ], -1)),
                _createVNode(_component_UserPicker, {
                  modelValue: _ctx.transferForm.to_user_id,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.transferForm.to_user_id) = $event)),
                  users: _ctx.meta ? _ctx.meta.users : [],
                  exclude: [Number(_ctx.lead ? _ctx.lead.owner_id : 0)]
                }, null, 8, ["modelValue", "users", "exclude"])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _cache[74] || (_cache[74] = _createElementVNode("label", null, [
                  _createTextVNode("Reason "),
                  _createElementVNode("span", { class: "req" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.transferForm.reason) = $event))
                }, [
                  _cache[73] || (_cache[73] = _createElementVNode("option", { value: "" }, "Select", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meta ? _ctx.meta.transfer_reasons : [], (r) => {
                    return (_openBlock(), _createElementBlock("option", { key: r }, _toDisplayString(r), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.transferForm.reason]
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _cache[75] || (_cache[75] = _createElementVNode("label", null, "Note", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.transferForm.note) = $event)),
                  placeholder: _ctx.needsNote(_ctx.meta, 'transfer_reason', _ctx.transferForm.reason) ? 'Required for this reason' : 'Optional'
                }, null, 8, _hoisted_71), [
                  [_vModelText, _ctx.transferForm.note]
                ])
              ])
            ]),
            _: 1
          }, 8, ["open", "busy", "onSubmit"]),
          _createVNode(_component_FormSheet, {
            open: _ctx.sheet === 'close',
            title: "Close lead",
            "submit-label": "Close lead",
            danger: "",
            busy: _ctx.busy,
            onClose: _cache[35] || (_cache[35] = ($event: any) => (_ctx.sheet = null)),
            onSubmit: _ctx.submitClose
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_72, [
                _cache[78] || (_cache[78] = _createElementVNode("label", null, "Close as", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.closeForm.close_as) = $event))
                }, [...(_cache[77] || (_cache[77] = [
                  _createElementVNode("option", null, "Lost", -1),
                  _createElementVNode("option", null, "Disqualified", -1)
                ]))], 512), [
                  [_vModelSelect, _ctx.closeForm.close_as]
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _cache[80] || (_cache[80] = _createElementVNode("label", null, [
                  _createTextVNode("Reason "),
                  _createElementVNode("span", { class: "req" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.closeForm.reason) = $event))
                }, [
                  _cache[79] || (_cache[79] = _createElementVNode("option", { value: "" }, "Select", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meta ? _ctx.meta.close_reasons : [], (r) => {
                    return (_openBlock(), _createElementBlock("option", { key: r }, _toDisplayString(r), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.closeForm.reason]
                ])
              ]),
              _createElementVNode("div", _hoisted_74, [
                _cache[81] || (_cache[81] = _createElementVNode("label", null, "Details", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.closeForm.note) = $event)),
                  placeholder: _ctx.needsNote(_ctx.meta, 'lost_reason', _ctx.closeForm.reason) ? 'Required for this reason' : 'Optional'
                }, null, 8, _hoisted_75), [
                  [_vModelText, _ctx.closeForm.note]
                ])
              ]),
              _cache[82] || (_cache[82] = _createElementVNode("div", { class: "hint" }, "Upcoming meetings for this lead will be cancelled.", -1))
            ]),
            _: 1
          }, 8, ["open", "busy", "onSubmit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}